import { ReactElement } from 'react'
import { Provider as JotaiProvider } from 'jotai'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import queryClient from 'const/queryClient'
import CookieEnabled from 'guards/CookieEnabled'
import { IVAChatStatusProvider } from 'iva-react-web-ui'
import { jotaiStore } from '../store'

import Dashboard from './Dashboard'

const App = (): ReactElement => {
  return (
    <CookieEnabled>
      <JotaiProvider store={jotaiStore}>
        <QueryClientProvider client={queryClient}>
          <IVAChatStatusProvider>
            <Dashboard />
          </IVAChatStatusProvider>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </JotaiProvider>
    </CookieEnabled>
  )
}

export default App
